module.exports = __webpack_public_path__ + "img/World2015.79bc8ff3.png";